import { AbsoluteFill, Audio, staticFile } from "remotion";
import { preloadAudio } from "@remotion/preload";
import { useEffect } from "react";

interface AudioTrackProps {
    videoFolder: string;
    audioName: string;
    start: number;
    end: number;
    volume?: number;
}

export const AudioTrack = ({
    videoFolder,
    audioName,
    start,
    end,
    volume = 0.2,
}: AudioTrackProps) => {
    const audio = `${process.env.REACT_APP_URL_PUBLIC_VIDEO}/Videos/${videoFolder}/Audio/${audioName}`;
    useEffect(() => {
        preloadAudio(staticFile(audio));
    }, []);
    return (
        <AbsoluteFill>
            <Audio
                src={staticFile(audio)}
                volume={volume}
                startFrom={start}
                endAt={end}
            />
        </AbsoluteFill>
    );
};
